import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { OptionTypes } from '../shared/models/options/option-types.model';
import { PartnerOption } from '../shared/models/options/partner-option.model';

@Injectable({
  providedIn: 'root'
})
export class PartnerOptionService {
  private baseUrl = `${environment.urlConfig.serviceUrl}/partneroptions`;

  constructor(private http: HttpClient) { }

  getOption<T>(partnerId: number, optionType: OptionTypes): Observable<PartnerOption<T>> {
    return this.http.get<PartnerOption<T>>(`${this.baseUrl}/${partnerId}/${optionType}`);
  }

  getAll(partnerId: number): Observable<PartnerOption<any>[]> {
    return this.http.get<PartnerOption<any>[]>(`${this.baseUrl}/${partnerId}`);
  }

  save(options: PartnerOption<any>[]): Observable<any> {
    return this.http.put<any>(`${this.baseUrl}`, options);
  }
}